<zwi-widget>
  <div class="zwi-flex-center">
    <mat-form-field appearance="fill">
      <mat-label>Select series</mat-label>
      <mat-select [formControl]="series">
        @for (s of seriesOptions; track s) {
          <mat-option [value]="s.id">{{s.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="zwi-spacer"></div>
    @if (seriesSermons.length > 0) {
      <button (click)="save()" mat-raised-button color="primary">Save</button>
    }
  </div>
  @if (seriesSermons.length > 0) {
    <div>Drag to edit order of sermons</div>
    <zwi-draggable-sermon-list [sermons]="seriesSermons" (sortChange)="setSortedSermons($event)"></zwi-draggable-sermon-list>
  } @else {
    @if (series.value) {
      <div>No sermons found in this series.</div>
    } @else {
      <div>Select a series</div>
    }
  }
</zwi-widget>
